import {
  DEALER_CONTEXT_STORE_NAME,
  initializeDealerContextStore,
} from "@lyteflo/utils";

export const initPortalWebDealerContextStore = () => {
  initializeDealerContextStore({
    storage: window.localStorage,
    name: DEALER_CONTEXT_STORE_NAME,
  });
};
